var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataframe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_5823)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4.79785V5.79785C6 6.34985 5.552 6.79785 5 6.79785H4C3.448 6.79785 3 6.34985 3 5.79785V4.79785C3 4.24585 3.448 3.79785 4 3.79785H5C5.552 3.79785 6 4.24585 6 4.79785Z",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.499 4.79785V5.79785C13.499 6.34985 13.051 6.79785 12.499 6.79785H11.499C10.947 6.79785 10.499 6.34985 10.499 5.79785V4.79785C10.499 4.24585 10.947 3.79785 11.499 3.79785H12.499C13.051 3.79785 13.499 4.24585 13.499 4.79785Z",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 4.79785V5.79785C21 6.34985 20.552 6.79785 20 6.79785H19C18.448 6.79785 18 6.34985 18 5.79785V4.79785C18 4.24585 18.448 3.79785 19 3.79785H20C20.552 3.79785 21 4.24585 21 4.79785Z",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 19.7979V20.7979C6 21.3499 5.552 21.7979 5 21.7979H4C3.448 21.7979 3 21.3499 3 20.7979V19.7979C3 19.2459 3.448 18.7979 4 18.7979H5C5.552 18.7979 6 19.2459 6 19.7979Z",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.499 19.7979V20.7979C13.499 21.3499 13.051 21.7979 12.499 21.7979H11.499C10.947 21.7979 10.499 21.3499 10.499 20.7979V19.7979C10.499 19.2459 10.947 18.7979 11.499 18.7979H12.499C13.051 18.7979 13.499 19.2459 13.499 19.7979Z",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 14.2969H19C18.448 14.2969 18 13.8489 18 13.2969V12.2969C18 11.7449 18.448 11.2969 19 11.2969H20C20.552 11.2969 21 11.7449 21 12.2969V13.2969C21 13.8489 20.552 14.2969 20 14.2969Z",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 14.2969H4C3.448 14.2969 3 13.8489 3 13.2969V12.2969C3 11.7449 3.448 11.2969 4 11.2969H5C5.552 11.2969 6 11.7449 6 12.2969V13.2969C6 13.8489 5.552 14.2969 5 14.2969Z",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 19.7979V20.7979C21 21.3499 20.552 21.7979 20 21.7979H19C18.448 21.7979 18 21.3499 18 20.7979V19.7979C18 19.2459 18.448 18.7979 19 18.7979H20C20.552 18.7979 21 19.2459 21 19.7979Z",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 20.2969H13.5",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99902 5.29785H10.499",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.499 20.2969H5.99902",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 5.29785H18",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.499 6.79688V11.2969",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 18.7979V14.2979",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.499 14.2979V18.7979",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 11.2969V6.79688",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.7969V14.7969",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.999 12.7979H9.99902",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_5823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.797852)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataframe);
export default __webpack_public_path__ + "static/media/Dataframe.83641e22a6944088b6121f2b92d7b159.svg";
export { ForwardRef as ReactComponent };